import React, { useEffect, useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { Card, Col, Row, Upload } from "antd";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { MdDelete } from "react-icons/md";
import { toast } from "react-hot-toast";

const AttachmentsUpload = ({
  id,
  data,
  companyName,
  collection,
  setFiles,
}) => {
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    setAttachments(data);
  }, [data]);
  console.log("Props data", id, data, companyName, collection);
  const handleUpload = async (file) => {
    const newFileList = [...fileList, file];
    setFileList(newFileList);
    if(!id){
      setFiles(newFileList);
    }

    if (id) {
      setLoading(true);
      const uniqueIds = {}; // Helper object to keep track of seen ids
      const imagesUrl = []; // Helper object to keep track of seen ids
      const uniqueItems = newFileList.filter((item) => {
        // If the id is not in the uniqueIds object, add it and return true
        if (!uniqueIds[item.uid]) {
          uniqueIds[item.uid] = true;
          return true;
        }
        // If the id is already in the uniqueIds object, return false to filter it out
        return false;
      });
      for (const file of uniqueItems) {
        const storageRef = ref(storage, `/files/properties/${file.name}`);
        const uploadTask = uploadBytesResumable(storageRef, file);
        console.log("File Data***********", uploadTask);
        try {
          await uploadTask;

          // File uploaded successfully
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          const fileData = {
            downloadURL: downloadURL,
            id: file.uid,
            name: file.name,
            type: file.type,
            isDefault: false,
          };
          imagesUrl.push(fileData);
          console.log("Download URL for", file.name, ":", downloadURL);
        } catch (error) {
          console.error("Upload error for", file.name, ":", error);
        }
      }

      let prevArray = [];
      if (data?.length > 0) {
        prevArray = data;
      }
      const combinedArray = [...prevArray, ...imagesUrl];
      const object = {
        attachments: combinedArray,
      };
      const docRef = doc(db, "companies", companyName, collection, id);
      try {
        await updateDoc(docRef, object);
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    }
  };

  console.log("fileList", fileList);
  const props = {
    name: "file",
    multiple: false,
    beforeUpload: () => false, // Prevent automatic upload
    onChange(info) {
      handleUpload(info.file);
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const [hoveredItem, setHoveredItem] = useState(null);

  const trimFileName = (name, maxLength) => {
    if (name.length <= maxLength) {
      return name; // No need to trim if it's already within the limit
    } else {
      const extension = name.slice(name.lastIndexOf("."));
      const trimmedName =
        name.slice(0, maxLength - extension.length) + "..." + extension;
      return trimmedName;
    }
  };

  const handleMouseEnter = (index) => {
    setHoveredItem(index);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  const handleDeleteClick = async (index) => {
    const filteredFiles = attachments.filter((item) => {
      return item.id !== index;
    });
    setAttachments(filteredFiles);

    const object = {
      "attachments": filteredFiles,
    };

    const docRef = doc(db, "companies", companyName, collection, id);
    try {
      await updateDoc(docRef, object);
    } catch (err) {
      console.log(err);
    }
  };

  const updateStatus = async (uid) => {
    const updatedAttachments = attachments.map((item) => {
      if (item.id === uid) {
        return { ...item, isDefault: true };
      }
      return item;
    });

    setAttachments(updatedAttachments)
    console.log("updatedAttachments#########",updatedAttachments);
    
    const object = {
      "attachments": updatedAttachments,
    };

    const docRef = doc(db, "companies", companyName, collection, id);
    try {
      await updateDoc(docRef, object);
      toast.success("Status updated successfuly");
    } catch (err) {
      console.log("erooooorrr", err);
    }
  }

  console.log("attachments&&&&&&&&&&&&", attachments)

  return (
    <Card title="Attachments" bordered={false} style={{ marginBottom: 20 }}>
      <Upload.Dragger {...props} style={{ padding: 8 }}>
        <InboxOutlined />
        <span style={{ marginLeft: 8, fontSize: "16px" }}>
          {loading ? "Uploading..." : "Drag files here or click to upload."}
        </span>
      </Upload.Dragger>
      <br />
      {id ? (
        <Row gutter={[16, 16]} align="middle" justify="center">
          {attachments?.length > 0
            ? attachments?.map((item) => {
                const trimmedName = trimFileName(item.name, 20);
                const isHovered = item.id === hoveredItem;
                return (
                  <Col span={6}>
                    <div
                      className={`attachemnt-image-container hovered`}
                      onMouseEnter={() => handleMouseEnter(item.id)}
                      onMouseLeave={handleMouseLeave}
                    >
                      {/* {isHovered && ( */}
                        <MdDelete
                          className="delete-button"
                          size={22}
                          onClick={() => handleDeleteClick(item.id)}
                        />
                      {/* )} */}
                      <strong>{trimmedName}</strong>
                      <img src={item.downloadURL} alt="attachment" />
                      {/* <p className="onclick-text" onClick={()=>updateStatus(item.id)}>isDefault</p> */}
                    </div>
                  </Col>
                );
              })
            : null}
        </Row>
      ) : null}
    </Card>
  );
};

export default AttachmentsUpload;
